import { LoginForm } from 'pages/auth/Login'
import { axiosInstance } from 'utils/axiosInstance'

export const login = async (credentials: {
  username: string
  password: string
}): Promise<void> => {
  await axiosInstance.post<LoginForm>('/auth/login', credentials)
}

export const logout = async (): Promise<void> => {
  await axiosInstance.post('/auth/logout')
}
